import script from "./ProfileManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileManagement.vue?vue&type=script&setup=true&lang=js"

import "./ProfileManagement.vue?vue&type=style&index=0&id=c4e7c74a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4e7c74a"]])

export default __exports__